import { render, staticRenderFns } from "./indexBox.vue?vue&type=template&id=28bb86f8&scoped=true&"
import script from "./indexBox.vue?vue&type=script&lang=js&"
export * from "./indexBox.vue?vue&type=script&lang=js&"
import style0 from "./indexBox.vue?vue&type=style&index=0&id=28bb86f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb86f8",
  null
  
)

export default component.exports